/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetExamsPackageDto
 */
export interface GetExamsPackageDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamsPackageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamsPackageDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamsPackageDto
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetExamsPackageDto
     */
    author?: GetUserDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamsPackageDto
     */
    type?: GetExamsPackageDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamsPackageDto
     */
    mode?: GetExamsPackageDtoModeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamsPackageDto
     */
    number?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamsPackageDto
     */
    examsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamsPackageDto
     */
    examsFinishCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamsPackageDto
     */
    examsExpectationCount?: number | null;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetExamsPackageDto
     */
    company?: GetCompanyDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamsPackageDto
     */
    sendCompanyEmail?: boolean | null;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetExamsPackageDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
}


/**
 * @export
 */
export const GetExamsPackageDtoTypeEnum = {
    Single: 'Single',
    Mulitiple: 'Mulitiple'
} as const;
export type GetExamsPackageDtoTypeEnum = typeof GetExamsPackageDtoTypeEnum[keyof typeof GetExamsPackageDtoTypeEnum];

/**
 * @export
 */
export const GetExamsPackageDtoModeEnum = {
    Exams: 'Exams',
    Normalization: 'Normalization'
} as const;
export type GetExamsPackageDtoModeEnum = typeof GetExamsPackageDtoModeEnum[keyof typeof GetExamsPackageDtoModeEnum];


/**
 * Check if a given object implements the GetExamsPackageDto interface.
 */
export function instanceOfGetExamsPackageDto(value: object): value is GetExamsPackageDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetExamsPackageDtoFromJSON(json: any): GetExamsPackageDto {
    return GetExamsPackageDtoFromJSONTyped(json, false);
}

export function GetExamsPackageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamsPackageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'registrationDate': json['registrationDate'] == null ? undefined : (new Date(json['registrationDate'])),
        'author': json['author'] == null ? undefined : GetUserDtoFromJSON(json['author']),
        'type': json['type'] == null ? undefined : json['type'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'number': json['number'] == null ? undefined : json['number'],
        'examsCount': json['examsCount'] == null ? undefined : json['examsCount'],
        'examsFinishCount': json['examsFinishCount'] == null ? undefined : json['examsFinishCount'],
        'examsExpectationCount': json['examsExpectationCount'] == null ? undefined : json['examsExpectationCount'],
        'company': json['company'] == null ? undefined : GetCompanyDtoFromJSON(json['company']),
        'sendCompanyEmail': json['sendCompanyEmail'] == null ? undefined : json['sendCompanyEmail'],
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
    };
}

export function GetExamsPackageDtoToJSON(value?: GetExamsPackageDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'description': value['description'],
        'registrationDate': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString()),
        'author': GetUserDtoToJSON(value['author']),
        'type': value['type'],
        'mode': value['mode'],
        'number': value['number'],
        'examsCount': value['examsCount'],
        'examsFinishCount': value['examsFinishCount'],
        'examsExpectationCount': value['examsExpectationCount'],
        'company': GetCompanyDtoToJSON(value['company']),
        'sendCompanyEmail': value['sendCompanyEmail'],
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
    };
}

